module.exports = __webpack_public_path__ + "static/media/cut.723b8f0e.svg";